export default __webpack_public_path__ + "static/media/E Commerce E Brochure Service.f28d1b0f.png";